enum HeaderFooterDialogFields {
	MODE = "mode",
	FONT_FAMILY = "font_family",
	FONT_SIZE = "font_size",
	FONT_COLOR = "font_color",
	UNDERLINE = "underline",
	MARGIN_LEFT = "margin_left",
	MARGIN_RIGHT = "margin_right",
	MARGIN_TOP = "margin_top",
	MARGIN_BOTTOM = "margin_bottom",
	PAGES_FROM = "pages_from",
	PAGES_TO = "pages_to",
	PAGES_FIRST = "pages_first",
	PAGES_FILTER = "pages_filter",
	HEADER_LEFT = "header_left",
	HEADER_LEFT_TYPE = "header_left_type",
	HEADER_LEFT_DATE = "header_left_date",
	HEADER_LEFT_PAGES = "header_left_pages",
	HEADER_LEFT_CUSTOM = "header_left_custom",
	HEADER_LEFT_BATES_PREFIX = "header_left_bates_prefix",
	HEADER_LEFT_BATES_SUFFIX = "header_left_bates_suffix",
	HEADER_LEFT_BATES_DIGITS = "header_left_bates_digits",
	HEADER_CENTER = "header_center",
	HEADER_CENTER_TYPE = "header_center_type",
	HEADER_CENTER_DATE = "header_center_date",
	HEADER_CENTER_PAGES = "header_center_pages",
	HEADER_CENTER_CUSTOM = "header_center_custom",
	HEADER_CENTER_BATES_PREFIX = "header_center_bates_prefix",
	HEADER_CENTER_BATES_SUFFIX = "header_center_bates_suffix",
	HEADER_CENTER_BATES_DIGITS = "header_center_bates_digits",
	HEADER_RIGHT = "header_right",
	HEADER_RIGHT_TYPE = "header_right_type",
	HEADER_RIGHT_DATE = "header_right_date",
	HEADER_RIGHT_PAGES = "header_right_pages",
	HEADER_RIGHT_CUSTOM = "header_right_custom",
	HEADER_RIGHT_BATES_PREFIX = "header_right_bates_prefix",
	HEADER_RIGHT_BATES_SUFFIX = "header_right_bates_suffix",
	HEADER_RIGHT_BATES_DIGITS = "header_right_bates_digits",
	FOOTER_LEFT = "footer_left",
	FOOTER_LEFT_TYPE = "footer_left_type",
	FOOTER_LEFT_DATE = "footer_left_date",
	FOOTER_LEFT_PAGES = "footer_left_pages",
	FOOTER_LEFT_CUSTOM = "footer_left_custom",
	FOOTER_LEFT_BATES_PREFIX = "footer_left_bates_prefix",
	FOOTER_LEFT_BATES_SUFFIX = "footer_left_bates_suffix",
	FOOTER_LEFT_BATES_DIGITS = "footer_left_bates_digits",
	FOOTER_CENTER = "footer_center",
	FOOTER_CENTER_TYPE = "footer_center_type",
	FOOTER_CENTER_DATE = "footer_center_date",
	FOOTER_CENTER_PAGES = "footer_center_pages",
	FOOTER_CENTER_CUSTOM = "footer_center_custom",
	FOOTER_CENTER_BATES_PREFIX = "footer_center_bates_prefix",
	FOOTER_CENTER_BATES_SUFFIX = "footer_center_bates_suffix",
	FOOTER_CENTER_BATES_DIGITS = "footer_center_bates_digits",
	FOOTER_RIGHT = "footer_right",
	FOOTER_RIGHT_TYPE = "footer_right_type",
	FOOTER_RIGHT_DATE = "footer_right_date",
	FOOTER_RIGHT_PAGES = "footer_right_pages",
	FOOTER_RIGHT_CUSTOM = "footer_right_custom",
	FOOTER_RIGHT_BATES_PREFIX = "footer_right_bates_prefix",
	FOOTER_RIGHT_BATES_SUFFIX = "footer_right_bates_suffix",
	FOOTER_RIGHT_BATES_DIGITS = "footer_right_bates_digits"
}

export default HeaderFooterDialogFields;